<template>
  <div style="width: 100%">
    <div class="text-center" style="width: 100%">
      <button class="card-tarja-btn" @click="handleClick" :disabled="isDisabled">
        <v-icon>mdi-television</v-icon>
        <span>Tarja</span>
      </button>
    </div>

    <ModalConfirmAction
      :visible="showDialog"
      title="Exibir na tarja"
      message="Tem certeza que deseja exibir a mensagem na tarja?"
      confirm-text="Exibir"
      confirm-color="primary"
      :loading="loading"
      @confirm="confirmExibir"
      @cancel="showDialog = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { apiClient } from "@/services/api";
import ModalConfirmAction from "@/components/Modal/ModalConfirmAction.vue";

export default {
  components: { ModalConfirmAction },
  props: {
    codProducao: Number,
    idColaboracao: String,
    isDisabled: Boolean,
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      exibirModalConfirmacao: null,
    };
  },
  async created() {
    if (this.codProducao) {
      await this.getConfigTarja({ cod_producao: this.codProducao });
      this.exibirModalConfirmacao = this.configTarja.flg_botao_confirmar_exibicao;
    }
  },
  computed: {
    ...mapGetters({
      configTarja: "tarja/getterConfigTarja",
    }),
  },
  methods: {
    ...mapActions({
      assignTarjaParams: "colaboracoes_moderadas/assignTarjaParams",
      getConfigTarja: "tarja/getConfigTarja",
    }),
    handleClick() {
      if (this.exibirModalConfirmacao) {
        this.showDialog = true;
      } else {
        this.setColaboracaoTarja();
      }
    },
    confirmExibir() {
      this.setColaboracaoTarja();
    },
    async setColaboracaoTarja() {
      this.loading = true;
      await apiClient.patch("/atualizarFlgIsFullScreen", {
        cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        flg_is_fullscreen: false,
      });
      const value = {
        codProducao: this.codProducao,
        idColaboracao: this.idColaboracao,
        isFullScreen: false,
      };
      this.assignTarjaParams(value);
      localStorage.setItem("tarjaParams", JSON.stringify(value));
      this.$emit("change");
      setTimeout(() => {
        this.loading = false;
        this.showDialog = false;
      }, 250);
    },
  },
  watch: {
    "$store.state.tarja.configTarja": function (newValue) {
      this.exibirModalConfirmacao = newValue.flg_botao_confirmar_exibicao;
    },
    codProducao: async function (value) {
      if (!value) return;
      await this.getConfigTarja({ cod_producao: value });
    },
  },
};
</script>

